<template>
  <div class="grid grid-cols-1 gap-6 xl:grid-cols-3">
    <div class="order-last space-y-6 xl:order-first xl:col-span-2">
      <basic-data-component></basic-data-component>
      <change-password-component></change-password-component>
    </div>
    <div class="xl:col-span-1">
      <user-avatar-component></user-avatar-component>
    </div>
  </div>
</template>

<script>
import UserAvatarComponent from "@/views/profile/avatar/UserAvatarComponent";
import ChangePasswordComponent from "@/views/profile/ChangePasswordComponent";
import BasicDataComponent from "@/views/profile/BasicDataComponent";

export default {
  name: "ProfileEditComponent",
  components: {
    BasicDataComponent,
    ChangePasswordComponent,
    UserAvatarComponent,

  }
}
</script>

<style scoped>

</style>